
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.058 4.275H9.615l1.565-1.558a.683.683 0 00-.966-.967L7.975 3.962l-.796-1.361a.683.683 0 10-1.184.68l.619.994H3.892A2.042 2.042 0 001.85 6.317v5.444c0 1.128.914 2.042 2.042 2.042h8.166A2.042 2.042 0 0014.1 11.76V6.317a2.042 2.042 0 00-2.042-2.042zm0 1.361a.68.68 0 01.68.68v5.445a.68.68 0 01-.68.68H3.892a.68.68 0 01-.68-.68V6.317a.68.68 0 01.68-.68h8.166zM7.08 7.325a.5.5 0 00-.5.5v2.457a.5.5 0 00.748.434l2.15-1.228a.5.5 0 000-.869l-2.15-1.228a.5.5 0 00-.248-.066z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    